module.exports = __webpack_public_path__ + "img/noorderlicht.1567b998.jpg";